module.exports = __webpack_public_path__ + "img/info.5b55cc53.png";